interface IProps {
  haszopimchat: boolean;
  zopimchat: string | number;
}

export const register = (props: IProps) => {
  if (!props.haszopimchat) {
    return;
  }

  const script = document.createElement('script');
  script.innerHTML = `
      window.$zopim||(function(d,s){var z=$zopim=function(c){z._.push(c)},$=z.s=
      d.createElement(s),e=d.getElementsByTagName(s)[0];z.set=function(o){z.set.
      _.push(o)};z._=[];z.set._=[];$.async=!0;$.setAttribute("charset","utf-8");
      $.src="//v2.zopim.com/?${props.zopimchat}";z.t=+new Date;$.
      type="text/javascript";e.parentNode.insertBefore($,e)})(document,"script");
    `;
  return script;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const unregister = (props: IProps) => {
  delete (window as any).$zopim;
};
